import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { View } from '@olxbr/design-system'

import AccountReactivationChangePasswordTemplate from '../../templates/AccountReactivationChangePasswordTemplate'
import LogoTitle from '../../molecules/LogoTitle'
import medias from '../../../util/medias'

const ContentWrapper = styled(View)`
  padding: 24px 16px;
  ${medias.desktop`
    padding: 24px 56px;
  `}
`

const AccountReactivationChangePasswordPage = ({
  email,
  onError,
  onLoginClick,
  onReactivateClick,
  onRegisterClick,
  onSubmit,
  onSuccess,
  token,
  abTests,
}) => (
  <ContentWrapper>
    <LogoTitle title="Altere sua senha" />
    <AccountReactivationChangePasswordTemplate
      email={email}
      onError={onError}
      onLoginClick={onLoginClick}
      onReactivateClick={onReactivateClick}
      onRegisterClick={onRegisterClick}
      onSubmit={onSubmit}
      onSuccess={onSuccess}
      token={token}
      abTests={abTests}
    />
  </ContentWrapper>
)

AccountReactivationChangePasswordPage.propTypes = {
  email: PropTypes.string.isRequired,
  onError: PropTypes.func,
  onLoginClick: PropTypes.func.isRequired,
  onReactivateClick: PropTypes.func.isRequired,
  onRegisterClick: PropTypes.func.isRequired,
  onSubmit: PropTypes.func,
  onSuccess: PropTypes.func.isRequired,
  token: PropTypes.string.isRequired,
  abTests: PropTypes.string,
}

export default AccountReactivationChangePasswordPage
